import MenuEffect from "./MenuEffect";
import HttpErrorResponseModel from "../../models/HttpErrorResponseModel";
import ActionUtility from "../../utilities/ActionUtility";
import { ReduxDispatch } from "../../models/ReduxProps";
import IStore from "../../models/IStore";
import MenuModel from "./models/MenuModel";

type ActionUnion = undefined | HttpErrorResponseModel | MenuModel[];

export default class MenuAction {
    public static readonly REQUEST_MENUS: string = "MenuAction.REQUEST_MENUS";
    public static readonly REQUEST_MENUS_FINISHED: string = "MenuAction.REQUEST_MENUS_FINISHED";

    public static readonly REQUEST_PATHS: string = "MenuAction.REQUEST_PATHS";
    public static readonly REQUEST_PATHS_FINISHED: string = "MenuAction.REQUEST_PATHS_FINISHED";

    public static readonly REQUEST_ERROR: string = "MenuAction.REQUEST_ERROR";
    public static readonly REQUEST_ERROR_FINISHED: string = "MenuAction.REQUEST_ERROR_FINISHED";

    public static requestMenus(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<MenuModel[]>(
                dispatch,
                MenuAction.REQUEST_MENUS,
                MenuEffect.requestMenus
            );
        };
    }

    public static requestPaths(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<any> => {
            return await ActionUtility.createThunkEffect<MenuModel[]>(
                dispatch,
                MenuAction.REQUEST_PATHS,
                MenuEffect.requestMenus
            );
        };
    }

    public static requestError(): any {
        return async (dispatch: ReduxDispatch<ActionUnion>, getState: () => IStore): Promise<void> => {
            await ActionUtility.createThunkEffect<any>(dispatch, MenuAction.REQUEST_ERROR, MenuEffect.requestError);
        };
    }
}
